interface JsonLdProps {
  data: object;
}

function getCspNonce(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  return document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content || undefined;
}

export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      nonce={getCspNonce()}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
